<template>
	<svg
		:alt="alt"
		xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18">
		<path fill="#0D74B5" d="M890.833333,164 C891.059028,164 891.25434,164.079167 891.419271,164.2375 L894.752604,167.4375 C894.917535,167.595833 895,167.783333 895,168 C895,168.216667 894.917535,168.404167 894.752604,168.5625 L891.419271,171.7625 C891.25434,171.920833 891.059028,172 890.833333,172 C890.607639,172 890.412326,171.920833 890.247396,171.7625 C890.082465,171.604167 890,171.416667 890,171.2 L890,169 L890,169 C886.962434,169 884.5,171.462434 884.5,174.5 C884.5,177.537566 886.962434,180 890,180 C893.037566,180 895.5,177.537566 895.5,174.5 C895.5,173.947715 895.947715,173.5 896.5,173.5 C897.052285,173.5 897.5,173.947715 897.5,174.5 C897.5,178.642136 894.142136,182 890,182 C885.857864,182 882.5,178.642136 882.5,174.5 C882.5,170.357864 885.857864,167 890,167 L890,164.8 C890,164.583333 890.082465,164.395833 890.247396,164.2375 C890.412326,164.079167 890.607639,164 890.833333,164 Z" transform="translate(-882 -164)"/>
	</svg>
</template>

<script>
export default {
	props: {
		alt: String
	}
};
</script>
